export const messages = {
  en: {
    adminAuthOwner: {
      search: {
        title: 'Search Conditions',
        state: 'Please select status',
        appUserName: 'Please enter owner name',
        idCard: 'Please enter ID card',
        link: 'Please enter phone number'
      },
      list: {
        title: 'Owner Authentication'
      },
      table: {
        communityName: 'Community Name',
        appUserName: 'Owner',
        link: 'Phone',
        roomName: 'Room',
        ownerTypeCdName: 'Person Type',
        idCard: 'ID Card',
        stateName: 'Status',
        remark: 'Audit Remark',
        createTime: 'Apply Time',
        appTypeName: 'App Type'
      },
      status: {
        all: 'All',
        pending: 'Pending',
        success: 'Success',
        failed: 'Failed'
      },
      community: {
        all: 'All Communities',
        fetchError: 'Failed to load communities'
      },
      fetchError: 'Failed to load owner authentication data'
    }
  },
  zh: {
    adminAuthOwner: {
      search: {
        title: '查询条件',
        state: '请选择状态',
        appUserName: '请输入关联业主名称',
        idCard: '请输入关联业主身份证',
        link: '请输入关联业主手机号'
      },
      list: {
        title: '业主认证'
      },
      table: {
        communityName: '小区名称',
        appUserName: '业主',
        link: '手机号',
        roomName: '房屋',
        ownerTypeCdName: '人员类型',
        idCard: '身份证',
        stateName: '状态',
        remark: '审核说明',
        createTime: '申请时间',
        appTypeName: '手机端类型'
      },
      status: {
        all: '全部',
        pending: '待审核',
        success: '审核成功',
        failed: '审核失败'
      },
      community: {
        all: '全部小区',
        fetchError: '加载小区列表失败'
      },
fetchError: '加载业主认证数据失败'
    }
  },
  'zh-TW': {
    adminAuthOwner: {
      search: {
        title: '查詢條件',
        state: '請選擇狀態',
        appUserName: '請輸入關聯業主名稱',
        idCard: '請輸入關聯業主身份證',
        link: '請輸入關聯業主手機號'
      },
      list: {
        title: '業主認證'
      },
      table: {
        communityName: '小區名稱',
        appUserName: '業主',
        link: '手機號',
        roomName: '房屋',
        ownerTypeCdName: '人員類型',
        idCard: '身份證',
        stateName: '狀態',
        remark: '審核說明',
        createTime: '申請時間',
        appTypeName: '手機端類型'
      },
      status: {
        all: '全部',
        pending: '待審核',
        success: '審核成功',
        failed: '審核失敗'
      },
      community: {
        all: '全部小區',
        fetchError: '載入小區列表失敗'
      },
      fetchError: '載入業主認證數據失敗'
    }
  }
}